const map = {
	"./core/blue_team_no_background.webp": 59894,
	"./core/board.webp": 53725,
	"./core/crown.webp": 91506,
	"./core/holidays-background.webp": 11781,
	"./core/name-frame.webp": 56636,
	"./core/player-frame.webp": 39266,
	"./core/red_team_no_background.webp": 62385,
	"./core/santa-hat.webp": 22920,
	"./features/excalibur.webp": 28354,
	"./features/lady_of_lake.webp": 23349,
	"./features/lady_of_sea.webp": 23565,
	"./features/plot_cards.webp": 21740,
	"./features/trapper.webp": 81999,
	"./other/preview.webp": 52534,
	"./premium/eclipse-queen.webp": 2811,
	"./premium/puppeteer.webp": 27151,
	"./roles/anime/brute.webp": 87334,
	"./roles/anime/cleric.webp": 44346,
	"./roles/anime/evil_lancelot.webp": 63339,
	"./roles/anime/good_lancelot.webp": 95518,
	"./roles/anime/guinevere.webp": 5520,
	"./roles/anime/isolde.webp": 87690,
	"./roles/anime/lunatic.webp": 88008,
	"./roles/anime/merlin.webp": 53841,
	"./roles/anime/merlin_pure.webp": 26296,
	"./roles/anime/minion.webp": 72652,
	"./roles/anime/mordred.webp": 48187,
	"./roles/anime/morgana.webp": 59417,
	"./roles/anime/mystery.webp": 22471,
	"./roles/anime/oberon.webp": 69213,
	"./roles/anime/percival.webp": 93600,
	"./roles/anime/revealer.webp": 33528,
	"./roles/anime/revealer_hidden.webp": 26573,
	"./roles/anime/revealer_progress.webp": 25146,
	"./roles/anime/servant.webp": 86311,
	"./roles/anime/trickster.webp": 36417,
	"./roles/anime/tristan.webp": 51047,
	"./roles/anime/troublemaker.webp": 33495,
	"./roles/anime/unknown_lancelot.webp": 50623,
	"./roles/anime/witch.webp": 15705,
	"./roles/anime/wraith.webp": 5813,
	"./roles/brute.webp": 74201,
	"./roles/cleric.webp": 19303,
	"./roles/evil_lancelot.webp": 15840,
	"./roles/good_lancelot.webp": 40597,
	"./roles/guinevere.webp": 20847,
	"./roles/isolde.webp": 54567,
	"./roles/legacy/brute.webp": 95263,
	"./roles/legacy/cleric.webp": 22541,
	"./roles/legacy/evil_lancelot.webp": 93586,
	"./roles/legacy/good_lancelot.webp": 41015,
	"./roles/legacy/guinevere.webp": 3741,
	"./roles/legacy/isolde.webp": 75809,
	"./roles/legacy/lunatic.webp": 59313,
	"./roles/legacy/merlin.webp": 88146,
	"./roles/legacy/merlin_pure.webp": 6281,
	"./roles/legacy/minion.webp": 94679,
	"./roles/legacy/mordred.webp": 37994,
	"./roles/legacy/morgana.webp": 40324,
	"./roles/legacy/mystery.webp": 95078,
	"./roles/legacy/oberon.webp": 25422,
	"./roles/legacy/percival.webp": 81743,
	"./roles/legacy/revealer.webp": 53507,
	"./roles/legacy/revealer_hidden.webp": 96136,
	"./roles/legacy/revealer_progress.webp": 98607,
	"./roles/legacy/servant.webp": 4442,
	"./roles/legacy/trickster.webp": 69236,
	"./roles/legacy/tristan.webp": 58346,
	"./roles/legacy/troublemaker.webp": 98468,
	"./roles/legacy/unknown_lancelot.webp": 89332,
	"./roles/legacy/witch.webp": 7780,
	"./roles/legacy/wraith.webp": 96566,
	"./roles/lunatic.webp": 82891,
	"./roles/merlin.webp": 98392,
	"./roles/merlin_pure.webp": 62947,
	"./roles/minion.webp": 13505,
	"./roles/mordred.webp": 2496,
	"./roles/morgana.webp": 37990,
	"./roles/mystery.webp": 23256,
	"./roles/oberon.webp": 67864,
	"./roles/percival.webp": 60081,
	"./roles/revealer.webp": 2133,
	"./roles/revealer_hidden.webp": 40150,
	"./roles/revealer_progress.webp": 63401,
	"./roles/servant.webp": 99596,
	"./roles/trickster.webp": 65330,
	"./roles/tristan.webp": 61120,
	"./roles/troublemaker.webp": 87494,
	"./roles/unknown_lancelot.webp": 69858,
	"./roles/witch.webp": 62046,
	"./roles/wraith.webp": 84324,
	"./stickers/cleric-best.webp": 23355,
	"./stickers/merlin-detective.webp": 12563,
	"./stickers/merlin-think.webp": 27864,
	"./stickers/minion-oops.webp": 86648,
	"./stickers/mordred-puppet.webp": 42768,
	"./stickers/morgana-panic.webp": 45611,
	"./stickers/morgana-violin.webp": 65017,
	"./stickers/morgana-wow.webp": 82299,
	"./stickers/oberon-laugh.webp": 14241,
	"./stickers/oberon-smirk.webp": 94240,
	"./stickers/percival-shield.webp": 45066,
	"./stickers/percival-toast.webp": 92922,
	"./stickers/percival-worthy.webp": 67928,
	"./stickers/servant-victory.webp": 70768,
	"./stickers/servant-wave.webp": 51951,
	"./stickers/servant-yes.webp": 92549
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18898;